import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { TaskAction, TaskActionTypes } from '@actions/tasks.actions';

import { IWorkflowTask } from '@mediahaven/shared';
import { TaskState } from 'state';

export const taskAdapter: EntityAdapter<IWorkflowTask> = createEntityAdapter<IWorkflowTask>({
    selectId: task => task.TaskId
});

export const initialState: TaskState = taskAdapter.getInitialState();

export function tasksReducer(state = initialState, action: Action): TaskState {
    const taskAction: TaskAction = action as TaskAction;
    switch (taskAction.type) {
        case TaskActionTypes.AddOrUpdate:
            return taskAdapter.upsertOne(taskAction.task, state);
        case TaskActionTypes.Update:
            return taskAdapter.updateOne({ id: taskAction.id, changes: taskAction.changes }, state);
        case TaskActionTypes.Remove:
            return taskAdapter.removeOne(taskAction.id, state);
        case TaskActionTypes.Clear:
            return taskAdapter.removeAll(state);
        default:
            return state;
    }
}
